import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DataTable from './shared/DataTable';
import {observer} from "mobx-react";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
});

class Orders extends Component
{

    constructor(props)
    {
        super(props);
        this._validAuthStates = ['signedIn'];

        this.state = {
            searchTerm: "",
            modal: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
        this.handleClientInputChange = this.handleClientInputChange.bind(this);
        this.handleProductInputChange = this.handleProductInputChange.bind(this);
        this.handleOrderTypeInputChange = this.handleOrderTypeInputChange.bind(this);

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount()
    {
        this.props.orderStore.getOrderList();
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentWillUnmount()
    {
        clearTimeout(this.searchTimeout);
    }

    handleSearchInputChange(event)
    {
        this.props.orderStore.searchTerm = event.target.value;

        /* Only search once the user stops typing */
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => this.props.orderStore.searchOrder(), 300);
    }

    handleClientInputChange(event)
    {
        this.props.orderStore.selectedClient = event.target.value;
    }

    handleProductInputChange(event)
    {
        this.props.orderStore.selectedProduct = event.target.value;
    }

    handleOrderTypeInputChange(event)
    {
        this.props.orderStore.selectedOrderType = event.target.value;
    }

    toggleModal()
    {
        if (!this.state.modal)
        {
            this.props.orderStore.loadOptions();
        }

        this.setState({
            modal: !this.state.modal,
            selectedClient: null,
            selectedProduct: null
        });
    }

    addOrder()
    {
        if (this.props.orderStore.selectedClient !== null &&
            this.props.orderStore.selectedProduct !== null &&
            this.props.orderStore.selectedOrderType !== null)
        {
            this.props.orderStore.addOrder(
                this.props.orderStore.selectedClient,
                this.props.orderStore.selectedProduct,
                this.props.orderStore.selectedOrderType
            );
        }
    }

    render()
    {
        const {classes} = this.props;

        return (
            <Grid container>
                <Dialog
                    open={this.state.modal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Druckauftrag anlegen</DialogTitle>
                    <DialogContent>
                        <TextField
                            id="selectedClient"
                            name="selectedClient"
                            select
                            label="Kunde"
                            className={classes.textField}
                            fullWidth={true}
                            value={this.props.orderStore.selectedClient || ''}
                            onChange={this.handleClientInputChange}
                            SelectProps={{
                                native: true,
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            margin="normal"
                            InputLabelProps={{shrink: true}}>
                            {this.props.orderStore.clientOptions.map(client =>
                                <option key={client.uuid} value={client.uuid}>{client.company}</option>
                            )}
                        </TextField>
                        <br/>
                        <TextField
                            id="selectedProduct"
                            name="selectedProduct"
                            select
                            label="Produkt"
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.orderStore.selectedProduct || ''}
                            onChange={this.handleProductInputChange}
                            SelectProps={{
                                native: true,
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            margin="normal"
                            InputLabelProps={{shrink: true}}>
                            {this.props.orderStore.productOptions.map(product =>
                                <option key={product.uuid} value={product.uuid}>{product.name}</option>
                            )}
                        </TextField>
                        <br/>
                        <TextField
                            id="orderType"
                            name="orderType"
                            select
                            fullWidth={true}
                            label="Produktionsart"
                            className={classes.textField}
                            value={this.props.orderStore.selectedOrderType || ''}
                            onChange={this.handleOrderTypeInputChange}
                            SelectProps={{
                                native: true,
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            margin="normal"
                            InputLabelProps={{shrink: true}}>
                            {this.props.orderStore.orderTypeOptions.map(orderType =>
                                <option key={orderType.uuid} value={orderType.value}>{orderType.label}</option>
                            )}
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal}
                                className={classes.button}>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.addOrder()}
                                className={classes.button}>
                            Anlegen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid item>
                    <TextField
                        id="searchTerm"
                        name="searchTerm"
                        label="Suchbegriff"
                        type="search"
                        className={classes.textField}
                        margin="none"
                        value={this.props.orderStore.searchTerm}
                        onChange={this.handleSearchInputChange}/>
                </Grid>
                <Grid item>
                    <Button variant="contained" size="small" color="secondary" onClick={this.toggleModal}
                            className={classes.button}>
                        Druckauftrag anlegen
                    </Button>
                </Grid>
                <DataTable
                    store={this.props.orderStore}
                    rows={this.props.orderStore.orderList}
                    columns={this.props.orderStore.tableColumns}
                    history={this.props.history}
                />
            </Grid>
        );
    }
}

export default withStyles(styles)(observer(Orders));
